import React, { FC } from 'react'

import { INewsCard } from '../NewsSection'
import { Button } from 'src/components/ui'
import { ChevronNextIcon } from '@svgs'
import { useTranslation } from 'react-i18next'

interface INewsCardProps extends INewsCard {
  onReadMore: () => void
}

const NewsCard: FC<INewsCardProps> = ({ title, description, image, onReadMore }) => {
  const { t } = useTranslation()

  return (
    <article className="overflow-hidden md:flex-1 shrink self-stretch flex bg-inverse rounded-2xl p-4 md:p-4 md:pt-6 md:px-8 relative min-h-[11.125rem] md:min-h-[11.125rem]">
      <div className="relative z-10 flex flex-col max-w-[14.125rem] md:max-w-[22.5rem] w-full">
        <div className="flex z-10 flex-col h-full self-stretch mr-0 w-full text-white ">
          <div className="text-sm md:text-xl font-black leading-[1.05rem] md:leading-6">
            {title}
          </div>
          <p className="mt-1 text-xs md:text-sm mb-auto">{description}</p>
          <div className="mt-3">
            <Button onClick={onReadMore} variant={'secondary'} iconAfter={<ChevronNextIcon />}>
              {t('read_more')}
            </Button>
          </div>
        </div>
      </div>
      <div className="absolute inset-0 size-full pointer-events-none touch-none">
        <div className="absolute top-0 right-0 w-[50%] h-full">
          <img loading="lazy" src={image} alt="" className="object-cover size-full" />
          <div className="absolute top-0 left-0 h-full w-1/2 bg-banner-gradient" />
        </div>
      </div>
    </article>
  )
}

export default NewsCard
